import { PdfViewerPage as PlatformPdfViewerPage } from '@jarvis/platform-ui';

export function PdfViewerPage() {
  return (
    <PlatformPdfViewerPage
      filesLinkTo="/finance/secure-pharm-reports"
      filesLinkLabel="Secure Pharm Reports"
    />
  );
}
